import {Injectable} from '@angular/core';
import {forkJoin, Observable, of} from 'rxjs';
import {AuthService} from '../../components/auth/auth.service';
import {UserService} from '../../services/user.service';

@Injectable()
export class UserDataResolverService {

    constructor(
        private authService: AuthService,
        private userService: UserService
    ) {}

    public resolve(): Observable<any> {

        // Don't try to fetch data, if user is not logged in.
        // Auth state should be checked for routes additionally.
        return this.authService.userRole
            ? forkJoin([
                this.userService.resolveUserData()
            ])
            : of(null);
    }

}
